import { render, staticRenderFns } from "./allotDialog.vue?vue&type=template&id=527a7d45&scoped=true"
import script from "./allotDialog.vue?vue&type=script&lang=js"
export * from "./allotDialog.vue?vue&type=script&lang=js"
import style0 from "./allotDialog.vue?vue&type=style&index=0&id=527a7d45&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527a7d45",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('527a7d45')) {
      api.createRecord('527a7d45', component.options)
    } else {
      api.reload('527a7d45', component.options)
    }
    module.hot.accept("./allotDialog.vue?vue&type=template&id=527a7d45&scoped=true", function () {
      api.rerender('527a7d45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/call/component/allotDialog.vue"
export default component.exports